import React, { useState } from "react";
import Expander from "@amzn/meridian/expander";

const ControlledSectionExpander = ({ title, children }) => {
  const [open, setOpen] = useState();
  return (
    <Expander open={open} onChange={setOpen} title={title} type="section">
      {children}
    </Expander>
  );
};

export default ControlledSectionExpander;
